import React, { useEffect, useState } from "react";
import axios from "axios";
import EventVenueAdminUpload from "./component/EventVenueAdminUpload";
import { Range, getTrackBackground } from "react-range";

const MIN = 0;
const MAX = 10000;
const STEP = 10;

export default function EventVenuePage() {
    const [groupedRegions, setGroupedRegions] = useState({});
    const [activeSido, setActiveSido] = useState("");
    const [selectedSigungu, setSelectedSigungu] = useState([]);
    const [minCapacity, setMinCapacity] = useState(0); // 배열이 아니라 단일값으로

    const [keyword, setKeyword] = useState("");
    const [venues, setVenues] = useState([]);
    const [searchTriggered, setSearchTriggered] = useState(false);

    useEffect(() => {
        (async () => {
            const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/event-venue/region-list`);
            const grouped = res.data.reduce((acc, cur) => {
                const { sido, venueCount } = cur;
                if (!acc[sido]) {
                    acc[sido] = {
                        sido,
                        totalVenueCount: 0,
                        sigunguList: [],
                    };
                }
                acc[sido].totalVenueCount += venueCount;
                acc[sido].sigunguList.push(cur);
                return acc;
            }, {});
            setGroupedRegions(grouped);
            const firstSidoKey = Object.keys(grouped)[0];
            if (firstSidoKey) setActiveSido(firstSidoKey);
        })();
    }, []);

    const resetOptions = () => {
        setSelectedSigungu([])
        setVenues([])
    }

    const fetchVenues = async () => {

        setVenues([])
        const parsedSigungus = selectedSigungu.map(key => key.split("-")[1]);
        const parsedSidos = selectedSigungu.map(key => key.split("-")[0]);

        const params = {
            sidos: Array.from(new Set(parsedSidos)),
            sigungus: parsedSigungus,
            minCapacity: minCapacity,
            keyword: keyword.trim(),
        };

        const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/event-venue/search`, params);
        setVenues(res.data);
    };

    const toggleSigungu = (sido, sigungu) => {
        const key = `${sido}-${sigungu}`;
        if (selectedSigungu.includes(key)) {
            setSelectedSigungu(selectedSigungu.filter((k) => k !== key));
        } else {
            setSelectedSigungu([...selectedSigungu, key]);
        }
    };

    const toggleAllInSido = (sidoObj) => {
        const { sigunguList } = sidoObj;
        const allKeys = sigunguList.map((item) => `${item.sido}-${item.sigungu}`);
        const allSelected = allKeys.every((k) => selectedSigungu.includes(k));
        if (allSelected) {
            setSelectedSigungu(selectedSigungu.filter((k) => !allKeys.includes(k)));
        } else {
            setSelectedSigungu(Array.from(new Set([...selectedSigungu, ...allKeys])));
        }
    };

    return (
        <div className="min-h-screen">
            {/*<EventVenueAdminUpload />*/}
            <main className="max-w-screen-xl mx-auto p-6 space-y-6">
                <div className="bg-white rounded-xl shadow p-4">

                    {/* 🔹 슬라이더 단독 줄 */}
                    <div className="mb-4" align="center">
                        <label className="text-m font-medium block mb-1">최소 인원 범위</label>
                        <Range
                            values={[minCapacity]} // 단일값 배열
                            step={STEP}
                            min={MIN}
                            max={MAX}
                            onChange={(values) => setMinCapacity(values[0])} // values는 배열이지만, 첫 값만 사용
                            renderTrack={({ props, children }) => (
                                <div
                                    {...props}
                                    style={{
                                        ...props.style,
                                        height: "6px",
                                        width: "70%",
                                        background: getTrackBackground({
                                            values: [minCapacity],
                                            colors: ["#0d6efd", "#ccc"],
                                            min: MIN,
                                            max: MAX,
                                        }),
                                        borderRadius: "4px",
                                    }}
                                >
                                    {children}
                                </div>
                            )}
                            renderThumb={({ props }) => (
                                <div
                                    {...props}
                                    style={{
                                        ...props.style,
                                        height: "20px",
                                        width: "20px",
                                        borderRadius: "50%",
                                        backgroundColor: "#0d6efd",
                                        border: "2px solid white",
                                        boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.1)",
                                    }}
                                />
                            )}
                        />
                        <div className="text-sm mt-2">
                            최소 인원: {minCapacity}명 이상 수용가능한 공간만 검색
                        </div>
                    </div>

                    {/* 🔹 키워드 + 검색버튼 줄 */}
                    <div className="flex items-center gap-4 mb-6">

                        <input
                            type="text"
                            placeholder="행사장 이름 검색"
                            className="border rounded px-4 py-2 text-sm flex-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                        />
                        <button
                            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 text-sm"
                            onClick={() => {
                                setSearchTriggered(true);
                                fetchVenues();
                            }}
                        >
                            검색
                        </button>
                    </div>



                    {/* 지역 선택 UI */}
                    <div className="border rounded-lg p-4 flex gap-4">
                        <div className="w-1/3 border-r pr-4 max-h-60 overflow-y-auto">
                            <h3 className="mb-2 font-semibold">시·도</h3>
                            {Object.keys(groupedRegions).map((sidoKey) => {
                                const sidoObj = groupedRegions[sidoKey];
                                return (
                                    <div
                                        key={sidoKey}
                                        className={`p-2 cursor-pointer rounded flex justify-between items-center mb-1 hover:bg-gray-100 ${
                                            activeSido === sidoKey ? "bg-gray-200 font-semibold" : ""
                                        }`}
                                        onClick={() => setActiveSido(sidoKey)}
                                    >
                                        <span>{sidoKey.replace("특별시", "").replace("광역시", "").replace("도", "")}</span>
                                        <span className="text-xs text-gray-500">({sidoObj.totalVenueCount})</span>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="flex-1 max-h-60 overflow-y-auto">
                            {activeSido && groupedRegions[activeSido] && (
                                <>
                                    <div className="flex items-center mb-2 justify-between">
                                        <h3 className="font-semibold">
                                            시·군·구 ({groupedRegions[activeSido].sigunguList.length}개)
                                        </h3>
                                        <button
                                            className="border px-3 py-1 rounded text-sm hover:bg-gray-100"
                                            onClick={() => toggleAllInSido(groupedRegions[activeSido])}
                                        >
                                            {groupedRegions[activeSido].sigunguList.every((item) =>
                                                selectedSigungu.includes(`${item.sido}-${item.sigungu}`)
                                            )
                                                ? "전체 해제"
                                                : "전체 선택"}
                                        </button>
                                    </div>

                                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                                        {groupedRegions[activeSido].sigunguList.map((item) => {
                                            const key = `${item.sido}-${item.sigungu}`;
                                            const checked = selectedSigungu.includes(key);
                                            return (
                                                <label
                                                    key={key}
                                                    className="flex items-center bg-white border rounded p-2 hover:bg-gray-50 cursor-pointer"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="mr-2"
                                                        checked={checked}
                                                        onChange={() => toggleSigungu(item.sido, item.sigungu)}
                                                    />
                                                    <span className="text-sm">
                                                        {item.sigungu}
                                                        {/*<span className="ml-1 text-xs text-gray-500">*/}
                                                        {/*    ({item.venueCount})*/}
                                                        {/*</span>*/}
                                                    </span>
                                                </label>
                                            );
                                        })}
                                    </div>
                                </>
                            )}
                        </div>
                        <button
                            className="bg-gray-600 text-white px-2 py-1 rounded hover:bg-red-700 text-sm"
                            onClick={() => {
                                resetOptions();
                            }}
                        >
                            초기화
                        </button>
                    </div>

                </div>

                {/* 결과 테이블 */}
                {searchTriggered && (
                    <div className="slow-animation bg-white rounded-xl shadow p-4">
                        <table className="w-full table-auto">
                            <thead>
                            <tr className="border-b text-left">
                                {/*<th className="px-2 py-2 text-sm font-semibold text-gray-700">시·도</th>*/}
                                {/*<th className="px-2 py-2 text-sm font-semibold text-gray-700">시·군·구</th>*/}
                                <th className="px-2 py-2 text-sm font-semibold text-gray-700">주소</th>
                                <th className="px-2 py-2 text-sm font-semibold text-gray-700">사업장명</th>
                                <th className="px-2 py-2 text-sm font-semibold text-gray-700">세부공간</th>
                                <th className="px-2 py-2 text-sm font-semibold text-gray-700">인원</th>
                                <th className="px-2 py-2 text-sm font-semibold text-gray-700">특이사항</th>

                            </tr>
                            </thead>
                            <tbody>
                            {venues.map((venue, idx) => (
                                <tr key={idx} className="border-b last:border-0 hover:bg-gray-50">
                                    {/*<td className="px-2 py-2 text-sm">{venue.sido}</td>*/}
                                    {/*<td className="px-2 py-2 text-sm">{venue.sigungu}</td>*/}
                                    <td className="px-2 py-2 text-sm">{venue.address}</td>
                                    <td className="px-2 py-2 text-sm">{venue.businessName}</td>
                                    <td className="px-2 py-2 text-sm">{venue.detailSpace}</td>
                                    <td className="px-2 py-2 text-sm">
                                        {venue.minCapacity}-{venue.maxCapacity}명
                                    </td>
                                    <td className="px-2 py-2 text-sm">{venue.mergeAvailableRooms}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </main>
        </div>
    );
}